import React from 'react';

import { TextSkeleton } from '@gitbook/spine-react';

import { NavigationLink } from '../../navigation';
import { useAssertCurrentOrganizationId } from '../../state';
import { useSpace } from './useSpace';

type SpaceLinkProps = {
    spaceId: string;
};

/**
 * A link to a space, wrapped in a suspense boundary.
 */
export function SpaceLinkSuspense(props: SpaceLinkProps) {
    return (
        <React.Suspense fallback={<TextSkeleton className="inline-block w-18" />}>
            <SpaceLink {...props} />
        </React.Suspense>
    );
}

/**
 * A link to a space.
 */
export function SpaceLink(props: SpaceLinkProps) {
    const { spaceId } = props;
    const organizationId = useAssertCurrentOrganizationId();
    const space = useSpace({ organizationId, spaceId });

    return (
        <NavigationLink
            to={
                space
                    ? {
                          current: {
                              type: 'space',
                              organization: space.organization,
                              space: space.id,
                          },
                      }
                    : undefined
            }
        >
            {space?.title ?? 'Deleted space'}
        </NavigationLink>
    );
}
